var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgePills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9469 36.8275L45.0026 10.6275C41.2203 3.735 32.8783 0.71 25.5812 3.575C22.9638 1.3475 19.5715 0 15.8717 0C7.60214 0 0.875 6.7275 0.875 15V45C0.875 53.2725 7.60214 60 15.8742 60C22.5638 60 28.2435 55.5975 30.1709 49.54L31.4909 51.87C34.3357 57.0575 39.7079 59.995 45.2426 59.995C47.785 59.995 50.3623 59.375 52.7422 58.0675C56.4095 56.0575 59.0719 52.7375 60.2418 48.725C61.4118 44.71 60.9493 40.48 58.9469 36.8275ZM42.8027 11.8175L49.3924 24.1975L30.8709 34.355V15C30.8709 11.42 29.611 8.13 27.5111 5.55C33.3808 3.785 39.8054 6.355 42.8027 11.8175ZM15.8742 2.5C22.7663 2.5 28.3735 8.1075 28.3735 15V28.75H3.37487V15C3.37487 8.1075 8.98207 2.5 15.8742 2.5ZM15.8742 57.5C8.98207 57.5 3.37487 51.8925 3.37487 45V31.25H28.3735V45C28.3735 51.8925 22.7663 57.5 15.8742 57.5ZM57.8444 48.025C56.8595 51.4 54.6221 54.1875 51.5423 55.8775C48.4599 57.5675 44.9051 57.955 41.5353 56.9725C38.1605 55.9875 35.3731 53.75 33.6757 50.655L30.8584 45.6775C30.8684 45.4525 30.8734 45.2275 30.8734 45V37.205L50.5673 26.405L56.747 38.0175C58.4369 41.0975 58.8294 44.6525 57.8444 48.025Z",
    fill: "#664BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgePills);
export default __webpack_public_path__ + "static/media/knowledge-pills.bf9976c9cb6e048c042cae7a7277daca.svg";
export { ForwardRef as ReactComponent };